import { useEffect } from "react";
import Lenis from "lenis";

export default function useLenis() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });

        window.lenis = lenis;

        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.lenis = null;
        };
    }, []);
}

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.lenis) {
        window.lenis.scrollTo(el, { offset: -80, duration: 1.3 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}
